// removed by extract-text-webpack-plugin
module.exports = {"moduleSection":"_2Bs4K-wdfgFCQILRbXgOXD","clientsTableContainer":"_3nROdE7x2wQsv8NprFcEoU","table":"_3TX4ZHTgh0cD9ZABmLAFTj","greyButton":"_1cZTKScXm2_xL2son6EvBj","iconContainer":"_1fTJZkCzrsfdvXxMcDtM73"};


//////////////////
// WEBPACK FOOTER
// ./components/b2bCompany/b2bCompanyPolicyHistory.scss
// module id = 1590
// module chunks = 0